import React from 'react';
type MainLayoutProps = {
  children: React.ReactNode;
};
const MainLayout: React.FC<MainLayoutProps> = ({
  children
}) => {
  return <div className="w-full" data-id="element-115">{children}</div>;
};
export default MainLayout;